import React, { ReactNode } from "react";
import { ReactComponent as LoadingIcon } from "../../assets/icons/loading.svg";

type SubmitProps = {
  loading?: boolean;
  onSubmit?: any;
  children?: ReactNode;
  className?: string;
};

const PrimaryButton = (props: SubmitProps) => {
  return (
    <button
      className={`button primary ${props.className ?? ""}`}
      onClick={props.onSubmit}
      disabled={props.loading}
      style={{
        cursor: props.loading == true && "not-allowed",
        opacity: props.loading == true && 0.5,
      }}
    >
      {props.loading && <LoadingIcon style={{ fill: "#F6F6F6" }} />}
      <div className="text">{props.children}</div>
    </button>
  );
};

export default PrimaryButton;
